export default __webpack_public_path__ + "static/media/vib-icon.4d5ad68a.svg";